var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #eb1700;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #000;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #eb1700;\n        opacity: .2;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 131,
    height: 34,
    rx: 5,
    ry: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 130,
    height: 33,
    rx: 4.5,
    ry: 4.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.75,18.11c0-2.31,2.05-4.26,4.49-4.26,1.32,0,2.52.56,3.35,1.45l-1.71,1.5c-.38-.5-.98-.84-1.63-.84-1.13,0-2.09.98-2.09,2.15s.96,2.16,2.09,2.16c.66,0,1.25-.34,1.64-.84l1.7,1.49c-.83.9-2.03,1.46-3.35,1.46-2.44,0-4.49-1.95-4.49-4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.74,21.14h-2.87l-.42,1.1h-2.63l3.17-8.24h2.63l3.17,8.24h-2.63l-.42-1.1ZM42.08,19.42l-.77-2-.78,2h1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.52,14h2.33l3.21,4.41v-4.41h2.33v8.24h-2.33l-3.21-4.41v4.41h-2.33v-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.52,18.11c0-2.31,2.05-4.26,4.49-4.26,1.32,0,2.52.56,3.35,1.45l-1.71,1.5c-.38-.5-.98-.84-1.63-.84-1.13,0-2.09.98-2.09,2.15s.96,2.16,2.09,2.16c.66,0,1.25-.34,1.64-.84l1.7,1.49c-.83.9-2.03,1.46-3.35,1.46-2.44,0-4.49-1.95-4.49-4.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.63,16.07v.92h3.92v2.08h-3.92v1.09h4.31v2.08h-6.63v-8.24h6.63v2.07h-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.28,20.16v2.08h-6.17v-8.24h2.33v6.16h3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.45,20.16v2.08h-6.16v-8.24h2.33v6.16h3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.77,16.07v.92h3.92v2.08h-3.92v1.09h4.31v2.08h-6.63v-8.24h6.63v2.07h-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.26,14h3.07c2.88,0,4.92,1.7,4.92,4.11s-2.04,4.13-4.92,4.13h-3.07v-8.24ZM97.71,20.13c1.25,0,2.13-.84,2.13-2.01s-.89-2-2.13-2h-1.13v4.02h1.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.14ff5b7d02aa74813b3aefd7b48a5cce.svg";
export { ForwardRef as ReactComponent };